import { getCurrentInstance, Ref } from "vue";

export type OnResolve = (token: string) => void;

export type OnError = (error: unknown) => void;

export function useGrecaptchaV3(requestType: Ref<string>): {
  validateV3recaptcha: () => Promise<string>;
} {
  const instance = getCurrentInstance();

  if (instance == null) {
    throw new Error("Could not get current instance");
  }

  const globalProperties = instance.appContext.config.globalProperties;

  const validateV3recaptcha = async () => {
    await globalProperties.$recaptchaLoaded();
    return await globalProperties.$recaptcha(requestType.value);
  };

  return {
    validateV3recaptcha,
  };
}

export function useGrecaptchaV2(
  reCaptchaElement: Ref<HTMLElement>,
  v2SiteKey: Ref<string>
): { renderV2Recaptcha: () => Promise<string> } {
  const renderV2Recaptcha = (): Promise<string> => {
    return new Promise(function (onResolve: OnResolve, onError: OnError) {
      window.grecaptcha.render(reCaptchaElement.value, {
        sitekey: v2SiteKey.value,
        callback: onResolve,
        errorCallback: onError,
        expiredCallback: onError,
        //eslint-disable-next-line  @typescript-eslint/no-explicit-any
      } as any);
    });
  };
  return {
    renderV2Recaptcha,
  };
}
